module.exports = __webpack_public_path__ + "static/GlitchlessSonyax43-c9ef91eda83305dda933e185418e9f75.png";